import { render, staticRenderFns } from "./GradingGuidelinesBody.vue?vue&type=template&id=127c502c&scoped=true&"
import script from "./GradingGuidelinesBody.vue?vue&type=script&lang=js&"
export * from "./GradingGuidelinesBody.vue?vue&type=script&lang=js&"
import style0 from "./GradingGuidelinesBody.vue?vue&type=style&index=0&id=127c502c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c502c",
  null
  
)

export default component.exports